import Text from '@ingka/text';

import { useLoading } from '../../../hooks/useLoading';
import Button from '../../Skapa/Button/Button';
import Modal, { ModalFooter, ModalHeader, Prompt } from '../../Skapa/Modal/Modal';

type Labels = {
  modal: {
    title: string;
    body: string;
  };
  buttons: {
    secondary?: {
      label: string;
    };
    primary: {
      label: string;
    };
  };
};
enum LocalLoading {
  CONFIRM = 'confirm',
}
export interface ConfirmationModalProps {
  isOpen: boolean;
  labels: Labels;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}
export const ConfirmationModal = (props: ConfirmationModalProps) => {
  const { isOpen, labels, onClose, onConfirm } = props;
  const localLoading = useLoading<LocalLoading>([]);

  return (
    <Modal escapable={false} visible={isOpen} handleCloseBtn={() => onClose()} scrollLock={false}>
      <Prompt
        titleId="confirmation-prompt-modal"
        title={labels.modal.title}
        header={<ModalHeader />}
        footer={
          <ModalFooter>
            <Button
              fluid
              size="medium"
              text={labels.buttons.primary.label}
              type="primary"
              loading={localLoading.check(LocalLoading.CONFIRM)}
              onClick={async () => {
                localLoading.set(LocalLoading.CONFIRM);
                await onConfirm();
                localLoading.unset(LocalLoading.CONFIRM);
              }}
            />
            {labels.buttons.secondary && (
              <Button
                fluid
                size="medium"
                text={labels.buttons.secondary.label}
                type="secondary"
                disabled={localLoading.check(LocalLoading.CONFIRM)}
                onClick={onClose}
              />
            )}
          </ModalFooter>
        }
      >
        <Text tagName="p">{labels.modal.body}</Text>
      </Prompt>
    </Modal>
  );
};
